import { useCallback } from "react"

import { useTranslation } from "@bounce/i18n"

import { ReviewReason } from "@/libs/bounce/bounceSdk.types.gen"

export const useReviewReasonTranslation = () => {
  const { t } = useTranslation()

  const translate = useCallback(
    (reason: ReviewReason) => {
      switch (reason) {
        case ReviewReason.AdditionalSecurity:
          return t("hooks.useReviewReasonTranslation.additionalSecurity", "additional security")
        case ReviewReason.ConvenientLocation:
          return t("hooks.useReviewReasonTranslation.convenientLocation", "convenient location")
        case ReviewReason.EasyCico:
          return t("hooks.useReviewReasonTranslation.easyCico", "easy drop-off and pick-up")
        case ReviewReason.FastService:
          return t("hooks.useReviewReasonTranslation.fastService", "fast service")
        case ReviewReason.FriendlyStaff:
          return t("hooks.useReviewReasonTranslation.friendlyStaff", "friendly staff")
        case ReviewReason.OpenLate:
          return t("hooks.useReviewReasonTranslation.openLate", "open late")
        case ReviewReason.SafeLocation:
          return t("hooks.useReviewReasonTranslation.safeLocation", "safe location")
        case ReviewReason.GreatValue:
          return t("hooks.useReviewReasonTranslation.greatValue", "great value")
        case ReviewReason.Other:
          return t("hooks.useReviewReasonTranslation.other", "other")
        default:
          return null
      }
    },
    [t],
  )

  return { translate }
}
